import { useState, useEffect } from 'react';

const LOADING_MESSAGES = [
  'Waking up your Nub...',
  'Checking under the couch cushions...',
  'Asking the blockchain nicely...',
  'Dusting off pixels...',
  'Negotiating with Solana...',
  'Your Nub is putting on pants...',
  'Polishing that PFP glow...',
  'Bribing the validators...',
  'Untangling the metadata...',
  'Searching the Nubverse...',
  'Convincing your Nub to cooperate...',
  'Loading maximum vibes...',
  'Fetching your lil guy...',
  'Warming up the crayons...',
  'Your Nub was napping...',
  'Almost there, probably...',
  'Rummaging through the blockchain...',
  'Summoning your Nub from the void...',
  'Doing blockchain stuff...',
  'Asking Helius real nice...',
];

function shuffleArray<T>(arr: T[]): T[] {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

interface FunLoadingTextProps {
  intervalMs?: number;
}

export function FunLoadingText({ intervalMs = 2000 }: FunLoadingTextProps) {
  const [messages] = useState(() => shuffleArray(LOADING_MESSAGES));
  const [index, setIndex] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % messages.length);
        setFading(false);
      }, 300);
    }, intervalMs);

    return () => clearInterval(timer);
  }, [intervalMs, messages.length]);

  return (
    <span
      className={`inline-block transition-all duration-300 ${
        fading ? 'opacity-0 translate-y-1' : 'opacity-100 translate-y-0'
      }`}
    >
      {messages[index]}
    </span>
  );
}
